var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"queue-detail-desc-root-container"},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"bold"}},[_vm._v("备注")]),_c('Divider'),_c('p',[_vm._v(_vm._s(_vm.dataSource))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }